import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Col, Input, Modal, Row, Table } from 'antd';
import Title from 'antd/es/typography/Title';
import { ObjectiveSymbol } from 'app/config/constants';
import { getCurrentPlanPeriodOpen } from 'app/entities/common/common.reducer';
import { formatPoint, percent } from 'app/shared/util/percent';
import * as _ from 'lodash';
import { getEntitiesEvaluate, resetApprovalEntity, saveDraft } from './category-evaluation.reducer';
import { columnsEvaluation } from './config';
import SelfConfirmCompleteEvaluation from './confirm-complete/self/confirm-complete';

type ISelfEvaluationObjectiveKRProps = {
    isOpen: boolean;
    onClose: (isReload?: boolean) => void;
    accountTableId: string;
    accountableName: string;
};

const { Search } = Input;

export const SelfEvaluationObjectiveKRComponent = ({ isOpen, onClose, accountTableId, accountableName }: ISelfEvaluationObjectiveKRProps) => {
    const dispatch = useAppDispatch();
    const treeData = useAppSelector(state => state.categoryEvaluation.entityEvaluates);
    const loading = useAppSelector(state => state.categoryEvaluation.loading);
    const updating = useAppSelector(state => state.categoryEvaluation.updating);
    const account = useAppSelector(state => state.authentication.account);
    const currentPlanPeriod = useAppSelector(state => state.common.currentPlanPeriod);

    // innit state
    const [KRComments, setKRComments] = useState([])
    const [isOpenModalConfirmCompleteEvaluation, setOpenModalConfirmCompleteEvaluation] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);

    useEffect(() => {
        dispatch(getCurrentPlanPeriodOpen());
    }, [])

    useEffect(() => {
        if (currentPlanPeriod?.value)
            handleGetTreeOrg();
    }, [currentPlanPeriod])

    useEffect(() => {
        if (KRComments.length > 0) {
            // Tính tổng lại cho các node cha
            const updatedData = treeData.map((item) => {
                if (item.children) {
                    return {
                        ...item, // Create a new object, spreading the original properties
                        point: calculateTotalAmount(item), // Update the point for the new object
                    };
                }
                return item;
            });
            setDataSource(updatedData);
        }
    }, [KRComments])

    useEffect(() => {
        if (treeData.length > 0) {
            const allRowKeys = getAllRowKeys(treeData);
            setExpandedRowKeys(allRowKeys);
            const krs = getAllChildren(treeData)
            setKRComments(krs.map(x => {
                return {
                    itemId: x.itemId,
                    agree: x.isAgree,
                    comment: x.feedbackContent,
                    contribution: x.contribution,
                    point: formatPoint(x.point),
                }
            }))
        }
    }, [treeData])

    const getAllRowKeys = (item) => {
        return item.reduce((keys, value, idx) => {
            keys.push(`${value?.itemId}`);

            if (value.children) {
                keys = keys.concat(getAllRowKeys(value.children));
            }

            return keys;
        }, []);
    };

    const getAllChildren = (nodes) => {
        let children = [];
        nodes.forEach(node => {
            children = children.concat(node.children); // Add the current node
        });
        return children;
    };

    // Hàm tính tổng cho mỗi node cha
    const calculateTotalAmount = (node) => {
        // Tổng giá trị của node và các con của nó
        const childTotal = node.children ? _.sumBy(_.filter(KRComments, o => node.children.map(x => x.itemId).includes(o.itemId)), o => percent(o.point) * o.contribution) : 0;
        return childTotal;
    };

    const handleGetTreeOrg = () => {
        dispatch(getEntitiesEvaluate({ ownerId: account?.id, accountTableId, planPeriodId: currentPlanPeriod?.value }))
    }

    const handleExport = (values) => {
        console.log(values);
    }

    const handleFreeTextSearchQuery = query => {
        // dispatch(setListFilterApprovalLevel({ ...filters, searchText: query }))
    };

    const handleClose = (reload = undefined) => {
        dispatch(resetApprovalEntity())
        onClose(reload);
    };

    const handleMapPayloadSaveDraft = () => {
        const payload = {
            ownerId: accountTableId,
            userId: account?.id,
            evaluateLevelId: treeData.length > 0 ? treeData[0]?.processingLevelId : undefined,
            evaluateFeedbackItems: KRComments.map(x => {
                return {
                    itemId: x.itemId,
                    isAgree: x.agree,
                    feedbackContent: x.comment,
                    point: percent(x.point)
                };
            })
        };
        return payload;
    }

    const handleOpenModalConfirmCompleteEvaluation = () => {
        setOpenModalConfirmCompleteEvaluation(true);
        // const payload = handleMapPayloadSaveDraft();
        // dispatch(saveDraft(payload)).then(res => {
        //     if (res && res.payload) {
        //     }
        // })
    }

    const handleCloseModalConfirmCompleteEvaluation = (isReload = false) => {
        setOpenModalConfirmCompleteEvaluation(false);
        if (isReload) {
            handleClose(isReload);
        }
    }

    return (
        <Modal open={isOpen} maskClosable={false} confirmLoading={updating} footer={null} onCancel={handleClose} width={'80vw'} className='view'>
            <div className="d-flex gap-5">
                <Title level={3}>Đánh giá kết quả thực hiện mục tiêu - {accountableName}</Title>
            </div>
            <div className="table">
                <div className="header">
                    <Col md={8}>
                        <Row className='w-100'>
                            <Col md={4}><Input disabled size='large' className='w-100' value={currentPlanPeriod?.label} /></Col>
                            <Col md={1} />
                            <Col md={18}>
                                <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
                            </Col>
                        </Row>
                    </Col>
                    <Col md={13}>
                        <Row className='w-100 justify-content-end gap-2'>
                            <Button size="large" onClick={handleOpenModalConfirmCompleteEvaluation} disabled={updating} className="green">
                                Xác nhận hoàn thành tự đánh giá
                            </Button>
                            {/* <Button size="large" onClick={handleExport} disabled={updating} className="primary">
                                Xuất File
                            </Button> */}
                        </Row>
                    </Col>
                </div>
                <Table tableLayout='fixed' scroll={{ y: '60vh' }} loading={loading || updating} bordered
                    dataSource={
                        dataSource.map(x => ({
                            ...x,
                            key: x.itemId,
                            children: x.children?.map(y => ({ ...y, key: y.itemId }))
                        }))
                    }
                    expandable={{
                        expandedRowKeys,
                        onExpandedRowsChange(newExpandedRowKeys: any) {
                            setExpandedRowKeys(newExpandedRowKeys);
                        },
                    }}
                    rowClassName={(record, index) =>
                        _.startsWith(record.itemCode, ObjectiveSymbol) ? "fw-bold" : "" // Định nghĩa lớp CSS cho dòng lẻ
                    }
                    pagination={false}
                    columns={columnsEvaluation}
                    summary={pageData => {
                        let totalContribution = 0;
                        let totalSelfEvaluate = 0;
                        let totalEvaluate = 0;

                        pageData.forEach(({ children, contribution, ratingPoint, point }) => {
                            totalContribution += contribution ?? 0;
                            totalSelfEvaluate += (ratingPoint * contribution)
                            totalEvaluate += (point * contribution);
                        });
                        return (
                            <Table.Summary fixed={'top'}>
                                <Table.Summary.Row className="fw-bold">
                                    <Table.Summary.Cell index={0}>
                                        Tổng cộng
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={1} />
                                    <Table.Summary.Cell align='center' index={2}>
                                        <span>{`${formatPoint(totalContribution)}%`}</span>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell colSpan={3} index={3} />
                                    <Table.Summary.Cell align='center' index={4}>
                                        <span>{`${formatPoint(totalSelfEvaluate / totalContribution)}%`}</span>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell colSpan={2} index={5} />
                                    <Table.Summary.Cell align='center' index={6}>
                                        <span>{`${formatPoint(totalEvaluate)}%`}</span>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell colSpan={3} index={6} />
                                </Table.Summary.Row>
                            </Table.Summary>
                        );
                    }}
                />
            </div>
            {isOpenModalConfirmCompleteEvaluation &&
                <SelfConfirmCompleteEvaluation
                    accountableName={accountableName}
                    accountTableId={accountTableId}
                    isOpen={isOpenModalConfirmCompleteEvaluation}
                    onClose={handleCloseModalConfirmCompleteEvaluation} />
            }
        </Modal>
    );
};

export default SelfEvaluationObjectiveKRComponent;
